<template>
  <footer class="onde-footer">
      <img
          src="../assets/img/common/onde.svg"
          class="logo"
          alt="Footer logo">
  </footer>
</template>

<script>
  export default {
    name: 'onde-footer'
  }
</script>

<style lang="scss" scoped>
  @import "../styles/styles";

  .onde-footer {
    @extend .text-right;
    border-top: 1px solid $border-color-dark;
    padding: 5px;
    img {
      width: 50px;
      height: auto;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Footer.component.vue